import currentUserId from "./currentUserId";
import api from "../../../services/api";

class TutorialDataService {
  getAllStaff = () => {
    let idUser = currentUserId();

    return api.get(`/retail/user/getallUsers/${idUser}`);
  };

  login = (UserLoginModel) => {
    return api.post("/retail/user/login", UserLoginModel);
  };

  getAllSuppliers = () => {
    let idUser = currentUserId();
    return api.get(
      `/retail/SocieteRestApi/allSocieteTypeClient/${"CLIENT"}/${"FOURNISSEUR"}/${idUser}/${1}/${0}`
    );
  };

  getAllProducts = () => {
    let idUser = currentUserId();

    return api.get(`/retail/product/getAllProducts/${idUser}`);
  };

  getAllWarehouse = () => {
    let idUser = currentUserId();
    return api.get(`/retail/warehouse/getAllWarehouse/${idUser}`);
  };

  getAllWareHouseManager = () => {
    let idUser = currentUserId();
    return api.get(
      `/retail/user/getUserByRole/${idUser}/${"WAREHOUSE_MANAGER"}`
    );
  };

  getAllTransporters = () => {
    let idUser = currentUserId();
    return api.get(`/retail/user/getUserByRole/${idUser}/${"TRANSPORTER"}`);
  };

  addRealWarehouse = (warehouseModel) => {
    let idUser = currentUserId();
    warehouseModel.idUser = idUser;
    return api.post("/retail/warehouse/addWarehouse", warehouseModel);
  };

  addProductPurchaseToVWareHouse = (ProductPurchaseModel) => {
    let idUser = currentUserId();
    ProductPurchaseModel.idUserCreation = idUser;
    return api.post(
      "/retail/productPurchase/addProductPurchaseToVWareHouse",
      ProductPurchaseModel
    );
  };

  getProductQuantitytByWarehouse = (ProductQteAndWarehouse) => {
    return api.get(
      `/retail/warehouse/getProductQuantitytByWarehouse/${ProductQteAndWarehouse.idWarehouse}/${ProductQteAndWarehouse.idProduct}`
    );
  };

  getProductsByWarehouse = (idWarehouse) => {
    let idUser = currentUserId();

    return api.get(
      `/retail/warehouse/getProductsByWarehouse/${idUser}/${idWarehouse}`
    );
  };

  addWarehouseTransaction = (warehouseTransactionModel) => {
    let idUser = currentUserId();
    warehouseTransactionModel.userCreation = idUser;
    return api.post(
      "/retail/warehouse/addWarehouseTransaction",
      warehouseTransactionModel
    );
  };

  getAllBrands = (isDeleted) => {
    let idUser = currentUserId();
    console.log("idUser", idUser);
    return api.get(`/retail/product/getAllBrand/${idUser}/${isDeleted}`);
  };

  addProductBrand = (brandModel) => {
    let idUser = currentUserId();
    brandModel.idUserCreation = idUser;
    return api.post("/retail/product/addProductBrand", brandModel);
  };

  setBrandIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/deleteAndRestoreBrand/${idUser}/${deletedAndRestoreModel.idBrand}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  updateBrandData = (updateBrandModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/updateBrand/${idUser}/${updateBrandModel.idBrand}/${updateBrandModel.newName}/${updateBrandModel.newDescription}`
    );
  };

  addProductFamily = (familyModel) => {
    // let idUser = currentUserId();
    // familyModel.idUserCreation = idUser;
    return api.post("/retail/product/addProductFamily", familyModel);
  };

  getAllFamilies = (isDeleted) => {
    let idUser = currentUserId();
    return api.get(`/retail/product/getAllFamily/${idUser}/${isDeleted}`);
  };

  setFamilyIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/deleteAndRestoreFamily/${idUser}/${deletedAndRestoreModel.idFamily}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  updateFamilyData = (updateFamilyModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/updateFamily/${idUser}/${updateFamilyModel.idFamily}/${updateFamilyModel.newName}/${updateFamilyModel.newDescription}`
    );
  };

  //subFamily
  getAllSubFamilies = (isDeleted) => {
    let idUser = currentUserId();
    return api.get(`/retail/product/getAllSublFamily/${idUser}/${isDeleted}`);
  };

  setSubFamilyIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/deleteAndRestoreSubFamily/${idUser}/${deletedAndRestoreModel.idSubFamily}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  addProductSubFamily = (subFamilyModel) => {
    let idUser = currentUserId();
    subFamilyModel.idUserCreation = idUser;

    return api.post("/retail/product/addProductSubFamily", subFamilyModel);
  };

  updateSubFamilyData = (updateSubFamilyModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/updateSubFamily/${idUser}/${updateSubFamilyModel.idSubFamily}/${updateSubFamilyModel.newName}/${updateSubFamilyModel.newDescription}`
    );
  };
  getAllSubFamiliesByFamilyId = (idFamily) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/product/getSublFamilyByFamilyId/${idUser}/${idFamily}`
    );
  };

  //Categories
  getAllCategories = (isDeleted) => {
    let idUser = currentUserId();
    return api.get(`/retail/product/getAllCategory/${idUser}/${isDeleted}`);
  };

  setCategoryIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/deleteAndRestoreCategory/${idUser}/${deletedAndRestoreModel.idCategory}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  addProductCategory = (categoryModel) => {
    // let idUser = currentUserId();
    // categoryModel.idUserCreation = idUser;

    return api.post("/retail/product/addProductCategory", categoryModel);
  };

  updateCategoryData = (updateCategoryModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/updateCategory/${idUser}/${updateCategoryModel.idCategory}/${updateCategoryModel.newName}/${updateCategoryModel.newDescription}`
    );
  };

  getAllCategoriesBySubFamilyId = (idSubFamily) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/product/getCategoryBySubFamilyId/${idUser}/${idSubFamily}`
    );
  };

  // Products

  addProduct = (productModel) => {
    let idUser = currentUserId();
    productModel.idUserCreation = idUser;

    return api.post("/retail/product/addProduct", productModel);
  };
  getAllProductsByFilter = (filterModel) => {
   

    return api.get(
      `/retail/product/getAllProductsByFilters/${filterModel.idUser}/${filterModel.isDeleted}/${filterModel.brandId}/${filterModel.categoryId}/${filterModel.dateDebut}/${filterModel.dateFin}/${filterModel.codearticle}`
    );
  };

  setProductIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/product/deleteAndRestoreProduct/${idUser}/${deletedAndRestoreModel.idProduct}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  getAllProductsBySubFamilyId = (elementId) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/product/getProductBySubFamily/${idUser}/${elementId}`
    );
  };

  getAllProductsByFamilyId = (elementId) => {
    let idUser = currentUserId();
    return api.get(`/retail/product/getProductByFamily/${idUser}/${elementId}`);
  };

  getAllProductsByCategoryId = (elementId) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/product/getProductByCategory/${idUser}/${elementId}`
    );
  };

  getAllProductsByBrandId = (elementId) => {
    let idUser = currentUserId();
    return api.get(`/retail/product/getProductByBrand/${idUser}/${elementId}`);
  };

  getProductById = () => {
    let idUser = currentUserId();
    let idProduct = sessionStorage.getItem("idProduct");
    return api.get(`/retail/product/getProductById/${idUser}/${idProduct}`);
  };

  // warehouse

  getAllRealWarehouses = (isDeleted) => {
    let idUser = currentUserId();
    return api.get(
      `/retail/warehouse/getAllRealWarehouse/${idUser}/${isDeleted}`
    );
  };

  setRealWarehouseIsDeletedField = (deletedAndRestoreModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/warehouse/deleteAndRestoreRealWarehouse/${idUser}/${deletedAndRestoreModel.idWarehouse}/${deletedAndRestoreModel.isDeleted}`
    );
  };

  updateRealWarehouseData = (updateWarehouseModel) => {
    let idUser = currentUserId();
    return api.post(
      `/retail/warehouse/updateRealWarehouse/${idUser}/${updateWarehouseModel.idWarehouse}/${updateWarehouseModel.newName}/${updateWarehouseModel.newReference}/${updateWarehouseModel.newDescription}/${updateWarehouseModel.idNewWarehouseManager}`
    );
  };

  // getProductsByWarehouse = ( idWarehouse) => {
  //   let idUser = currentUserId();
  //   return api.get(
  //     `/retail/warehouse/getProductsByWarehouse/${idUser}/${idWarehouse}`
  //   );
  // };

  addOrderPurchaseToWarehouse = (purchaseOrderModel) => {
    return api.post("/retail/purchaseOrder/addOrderPurchaseToWarehouse/", {
      params: {
        purchaseOrderModel,
      },
    });
  };
}

export default new TutorialDataService();
